import crypto from 'crypto';

const SECRET_KEY = 'jornada-java-dashboard-2024';

// Hash fixo para acesso ao dashboard
const DASHBOARD_HASH = 'jornada-java-dashboard-2024';

export const generateDashboardHash = (timestamp: number): string => {
  const data = `dashboard-${timestamp}-${SECRET_KEY}`;
  return crypto.createHash('sha256').update(data).digest('hex');
};

export const isValidDashboardHash = (hash: string | null): boolean => {
  if (!hash) return false;
  return hash === DASHBOARD_HASH;
}; 